module.exports = __webpack_public_path__ + "img/discuss.33dd0226.jpg";